module.exports = __webpack_public_path__ + "img/TZ.5081edd6.png";